import type { MouseEvent } from "react";
import { CheckOutlined } from "@ant-design/icons";
import { closeMethodRowSize } from "./closeLayout";

interface CloseMethodRowProps {
  label: string;
  isSelected: boolean;
  isDisabled: boolean;
  /** Скрит, но пази мястото си (трите клика на „В брой"). */
  isHidden?: boolean;
  isNarrow: boolean;
  /** Изгледът „Закрий" с бакшиш (и „Депозити"): редът е с височината на
   *  кутийките вляво (`CLOSE_BOX_HEIGHT`); иначе — старият `py-4`. */
  boxed: boolean;
  onClick: (event: MouseEvent) => void;
}

/**
 * Един метод на плащане в дясната колона — ЕДИН компонент за „Закрий",
 * „Плати избраните" и „Депозити", за да са 1:1. Неактивният ред е без топъл
 * фон, със сив текст и намалена опасити — чете се като недостъпен, не като избран.
 */
export function CloseMethodRow({
  label,
  isSelected,
  isDisabled,
  isHidden = false,
  isNarrow,
  boxed,
  onClick,
}: CloseMethodRowProps) {
  return (
    <button
      type="button"
      onClick={(event) => {
        if (isDisabled || isHidden) return;
        onClick(event);
      }}
      disabled={isDisabled}
      aria-pressed={isSelected}
      className={`flex items-center justify-between gap-2 border text-left transition-colors ${closeMethodRowSize(
        isNarrow,
        boxed,
      )} ${isHidden ? "invisible" : "visible"} ${
        isSelected ? "border-pos-accent/30 bg-pos-ready-bg" : "border-pos-line2 bg-pos-card"
      } ${isDisabled ? "cursor-not-allowed opacity-55" : "cursor-pointer"}`}
    >
      <span
        className={`truncate font-semibold ${isNarrow ? "text-[13.5px]" : "text-[15px]"} ${
          isDisabled ? "text-pos-muted" : isSelected ? "text-pos-accent-ink" : "text-pos-ink"
        }`}
      >
        {label}
      </span>
      <span
        className={`inline-flex shrink-0 items-center justify-center rounded-full border text-white ${
          isNarrow ? "h-5 w-5" : "h-[22px] w-[22px]"
        } ${isSelected ? "border-pos-accent bg-pos-accent" : "border-pos-ctl bg-pos-card"}`}
      >
        {isSelected && <CheckOutlined className="text-[11px]" />}
      </span>
    </button>
  );
}
